import ErrorIcon from '@mui/icons-material/Error';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', width: '100vw' }}>
      <Paper sx={{ m: 'auto', p: 12 }}>
        <Box sx={{ display: 'flex' }}>
          <ErrorIcon sx={{ color: 'var(--color-signal-error-error)', fontSize: 40, p: 2 }} />
          <Typography variant="h2">{t('notFound.title')}</Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;
